import { Pipe, PipeTransform, inject } from '@angular/core';
import { AddressService } from 'src/app/core/services/address.service';
import { Address } from '../models/address';

@Pipe({
  name: 'formatAddress',
})
export class FormatAddressPipe implements PipeTransform {
  private addressService = inject(AddressService);

  transform(address?: Address): any {
    return this.addressService.formatAddressToString(address);
  }
}
